export default "../fonts/akzidgrtskpromedcnd-webfont.de1ba0d6126a1fab014476add6bcaabe.woff";